.scroll {
  max-height: var(--card-list-height);
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* The point that, once visible, asks for more rows. */
.end {
  height: 1px;
}

.more {
  display: flex;
  justify-content: center;
  padding: var(--space-3);
}
